import { api } from "./configs/axiosConfigs"

export const AuthAPI = {

  login: async (username: string, rut_company: string, password: string, iduser_type: number) => {
    const response = await api.post('/auth/login',
      {
        username,
        rut_company,
        password,
        password_confirmation: password,
        iduser_type,
      }
    )
    .then(response => response.data.data)
    .catch((error) => {
      return error.response.data
    })

    return response
  },

  refresh: async (token: string) => {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`
    const response = await api.post(
      '/auth/refresh',
    ).then(response => response.data.data)
    .catch((error) => {
      console.error(error)
    })

    return response
  },

  logout: async () => {
    const response = await api.post(
      '/auth/logout'
    ).then(response => response.data.data)
    .catch((error) => {
      return error.response.data
    })
    
    return response
  },
}